module.exports = __webpack_public_path__ + "static/media/16.7de20a72.wav";